// extracted by mini-css-extract-plugin
export var searchHeader = "_j-0";
export var searchHeaderDark = "_j-1";